// Z35.1: shared 30s cache for list-page total-row counts, so navigating between pages of
// the same filtered list doesn't re-run `SELECT count(*)` on every click -- only the first
// fetch for a given (list, filter-set) combination requests a count; subsequent page/size
// changes within the TTL reuse it. Keyed by an arbitrary string the caller builds (typically
// `${paginationKey}:${JSON.stringify(filters)}`) so different filter combinations get their
// own cached total.
const cache = new Map<string, { count: number; expiresAt: number }>()
const TTL_MS = 30_000

export function getCachedCount(key: string): number | undefined {
  const hit = cache.get(key)
  if (!hit) return undefined
  if (hit.expiresAt <= Date.now()) {
    cache.delete(key)
    return undefined
  }
  return hit.count
}

export function setCachedCount(key: string, count: number): void {
  cache.set(key, { count, expiresAt: Date.now() + TTL_MS })
}

// Call after any create/delete (or a status change that would add/remove a row from a
// filtered view) so the next fetch re-counts instead of serving a now-stale total. Clears
// every cached filter-variant for this list, not just the currently-active one, since we
// don't track which specific filter combinations a given mutation affects.
export function invalidateCachedCount(paginationKey: string): void {
  const prefix = `${paginationKey}:`
  for (const k of cache.keys()) {
    if (k.startsWith(prefix)) cache.delete(k)
  }
}
